<template lang="pug">
    v-card(tile)
        v-card-title
            .subtitle-1.grey--text.font-weight-medium {{title}}
            v-spacer
            v-btn(dark color="primary" rounded @click="$emit('new', type)")
                v-icon(left) mdi-plus-circle
                span {{$t('general.new')}}
        v-card-title.pt-1
            v-divider
        v-card-text
            v-list(dense rounded)
                v-list-item(v-for="data in items" :key="data.id" @click="$emit('edit', {data, type})")
                    v-list-item-content
                        v-list-item-title {{data.name}}
                    v-list-item-action
                        v-icon(:color="statusColor(data.status)") {{statusIcon(data.status)}}
</template>

<script>
export default {
  name: "CardList",
  props: {
    type: {
      required: true,
      type: String
    },
    items: {
      required: true,
      type: Array
    }
  },
  computed: {
    title() {
      if (this.type === "companyType") return "Company Type";
      else if (this.type === "serviceType") return "Service Type";
      return "";
    }
  },
  methods: {
    statusColor(status) {
      return status ? "green" : "red";
    },
    statusIcon(status) {
      return status ? "mdi-check-circle-outline" : "mdi-alert-circle-outline";
    }
  }
};
</script>

<style scoped></style>
